import Vue from 'vue'
import Vuex from 'vuex'
import user from './module/user'
import {
    getAllCategory
} from '@/api/product'
Vue.use(Vuex)

// 格式化数据
function formatData (categoryItems) {
    categoryItems = categoryItems.map((val, key, arr) => {
        val.text = val.title
        if (val.children) {
            val.children.map((val1, key1, arr1) => {
                val1.text = val1.title
            })
            // 加个全部选项
            val.children.splice(0, 0, {
                text: '全部',
                parent_id: val.id,
                title: '全部'
            })
        }
        return val
    })
    return categoryItems
}

export default new Vuex.Store({
    state: {
        categoryList: [],
        scrollTop: 0,
        centrifugeRefresh: false,
        keekAlives:[],
        screenWidth: document.body.clientWidth,
    },
    mutations: {
        setScreenWidth(state, val) {
            state.screenWidth = val;
        },
        setCategoryList (state, data) {
            state.categoryList = data
        },
        setScrollTop (state, data) {
            state.scrollTop = data
        },
        setCentrifugeRefresh (state, data) { // 离心机筛选的组件是否更新数据
            state.centrifugeRefresh = data
        },
    },
    getters: {
        
    },
    actions: {
    // 获取类别列表
        getAllCategoryPort ({
            state,
            commit
        }) {
            return new Promise((resolve, reject) => {
                try {
                    getAllCategory().then(res => {
                        var categoryItems = res || []
                        categoryItems = formatData(categoryItems)
                        // console.log('打印类别数据', categoryItems)
                        commit('setCategoryList', categoryItems)
                    }).catch(err => {
                        console.log('获取类别数据失败', err)
                        reject(err)
                    })
                } catch (error) {
                    reject(error)
                }
            })
        }
    },
    modules: {
        user
    }
})
